// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module__card___2-lTU","title":"Card-module__title___3Aqtw","content":"Card-module__content___2LLgA","caption":"Card-module__caption___1V4Of"};